import { Controller } from '@hotwired/stimulus'

type ColorScheme = 'dark' | 'light'

export default class extends Controller {
  static override targets = ['toggle']
  declare readonly toggleTarget: HTMLInputElement
  declare readonly hasToggleTarget: boolean

  #themes = {
    light: 'nord',
    dark: 'sunset',
  }
  #cacheKey = 'app.color_scheme'

  override connect() {
    const savedColorScheme = localStorage.getItem(this.#cacheKey)
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches

    const colorScheme = savedColorScheme || (prefersDark ? 'dark' : 'light')
    this.setColorScheme(colorScheme as ColorScheme)

    if (this.hasToggleTarget) {
      this.toggleTarget.checked = colorScheme === 'dark'
    }
  }

  toggle({ target }: { target: HTMLInputElement }) {
    this.setColorScheme(target.checked ? 'dark' : 'light')
  }

  setColorScheme(colorScheme: ColorScheme) {
    document.documentElement.setAttribute('data-theme', this.#themes[colorScheme])
    document.body.style.colorScheme = colorScheme

    localStorage.setItem(this.#cacheKey, colorScheme)
  }
}
